import { Injectable } from '@angular/core';

import { FsMapTrafficServiceProvider, IFsMap } from '@lib/geo/core';

@Injectable()
export class MapTrafficFacadeService<
  TMap extends IFsMap = IFsMap,
> extends FsMapTrafficServiceProvider<TMap> {
  constructor(private readonly provider: FsMapTrafficServiceProvider<TMap>) {
    super();
  }

  public onMapLoaded(map: TMap): void {
    this.provider.onMapLoaded(map);
  }

  public addToMap(): void {
    this.provider.addToMap();
  }

  public removeFromMap(): void {
    this.provider.removeFromMap();
  }
}
